import React, { useEffect, useState,useRef } from 'react'
import transactionReportServices from '../../transaction/transactionReportServices';
import transactionServices from '../../transaction/transactionServices';
import { useAppData } from '../../../../../context/AppDataContext';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

function ProjectTransactionList({transactionItemList,getTransactionItemList}) {

    const {companyDD, getDDDataById, projectDD,transactionCategoryDD,employeeDD,vendorDD, getMasterLabel} = useAppData();
    const gridRef = useRef();

    const [defaultColDef] = useState({
        floatingFilter: true,
        filterParams: {
          buttons: ['apply'],
        },
        resizable: true,
        width:120,
        filter:true,
        sortable: true,
        cellStyle: { 'textTransform': 'uppercase' },
    });

    const [columnDefs,setColumnDef] = useState();
        const prepairColumnDef = () => {
        let _columnDefs = [
            {field:"id",headerName: "ID"},
            
            {headerName: "Company", width:300,
              valueGetter:params=>{
                return getDDDataById(companyDD,params.data.companyId).label;
              }
            }, 
            
            {field:"transactionDate",headerName: "T. Date"},
            {headerName: "Method",
              valueGetter:params=>{
                return getMasterLabel("transaction-method",params.data.transactionMethod);
              }
            },
            {field:"transactionNo",headerName: "Transaction #",width:150},

            {field:"amount",headerName: "Amount",width:120},


            {headerName: "Category", width:300,
              valueGetter:params=>{
                return getDDDataById(transactionCategoryDD,params.data.transactionCategory).label;
              }
            },

            {headerName: "Project", width:300,
              valueGetter:params=>{
                return getDDDataById(projectDD,params.data.projectId).label;
              }
            },

            {headerName: "Po #", width:300,
              valueGetter:params=>{
                return params.data.poNo===null?"--":params.data.poNo;
              }
            },

            {headerName: "Payee Type", width:300,
              valueGetter:params=>{
                return getDDDataById(transactionServices.payeeTypeList,params.data.payeeType).label;
              }
            },


            

            {headerName: "Paid To", width:300,
              valueGetter:params=>{
                if(params.data.payeeType == 1){
                    return getDDDataById(employeeDD,params.data.payeeId).label;
                }
                if(params.data.payeeType == 2){
                    return getDDDataById(vendorDD,params.data.payeeId).label;
                }

                if(params.data.payeeType == 11){
                    return params.data.payeeName;
                }
                
              }
            },
            
            /*
            {headerName:"Action", width:"200", valueGetter: params => params.data.title,
                cellRenderer: CellActions,
                cellRendererParams: {
                    callBack:getTransactionList,
                    remove:remove
                },
            },
            */      
        ];
        setColumnDef(_columnDefs);
    }
    
    const onBtnExport = () => {
        gridRef.current.api.exportDataAsCsv("data.csv");
    };
    
    useEffect(()=>{    
      prepairColumnDef();
    },[]);


    return (
        <div className='row'>
            <div className='col-md-12 mt-2'>
              <button className='btn btn-outline-primary' onClick={onBtnExport} >Export</button>
            </div>
            <div className='col-md-12 mt-2'>
                <div className="ag-theme-alpine" style={{height: 400}}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={transactionItemList}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={true}
                        onGridReady={getTransactionItemList}
                    />
                </div>
            </div>
        </div>
    )
}

export default ProjectTransactionList